module.exports = __webpack_public_path__ + "static/media/station-model.287f5cc3.jpg";